import { useMemo } from "react";

export const useFormFooter = (
  defaultFooter: string | null | undefined,
): string => {
  return useMemo(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(defaultFooter || "", "text/html");
    doc.querySelectorAll("a").forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
    return doc.body.innerHTML;
  }, [defaultFooter]);
};
